import React,{useState}  from 'react';
import Categories from "../../components/layout/scrap/Categories";
import AddCategory from "../../components/layout/scrap/AddCategory";

const NewsScrapPage = () => {
    const [changeSensor, setChangeSensor] = useState(false)
    const changeCategory = (bool) => setChangeSensor(bool)

    return (
        <div className='scrap container'>
            <div className='inner_container'>
                <AddCategory changeSensor={changeSensor} changeCategory={changeCategory}/>
                <div style={{height:'24px'}}/>
                <Categories  changeSensor={changeSensor} changeCategory={changeCategory}/>
            </div>
        </div>
    );
};

export default NewsScrapPage;